import { useEffect, useState } from 'react';
import { googleKey } from '../../../Services/Keys';
import { useBusinessCoordinates } from '../../../Data/Business';
import { b64SafeEncode } from '../../../Services/helpers';


const useMapUrl = (marker, exact, businessMarker) => {
    const width = Math.min(window.innerWidth, 640); // Maximum allowed size
    const height = Math.round(width / 2);
    const [url, setUrl] = useState(null);
    const { coordinates: businessCoordinates } = useBusinessCoordinates();

    useEffect(() => {
        if (!marker || !businessCoordinates) {
            return;
        }
        const markers = [
            { icon: exact ? 'circle-dot' : 'circle', latitude: marker.latitude, longitude: marker.longitude },
        ]
        if (businessMarker && businessCoordinates) {
            markers.push({
                size: 'small',
                color: 'green',
                latitude: businessCoordinates.latitude,
                longitude: businessCoordinates.longitude
            })
        }

        const url = makeUrl([width, height], markers);

        const encoded = b64SafeEncode(url);
        const complete = 'https://gspy.uk/m/d/' + encoded;

        setUrl(complete);

    }, [marker, businessCoordinates, exact, businessMarker, width, height]);

    return url;
}

const makeUrl = (size, markers, location, zoom) => {
    const icons = {
        // The ? Breaks google cache of the image... eventually it can go
        'circle': 'icon:' + encodeURIComponent('https://gspy.uk/images/map-circle.png?') + '%7Canchor:center',
        'circle-dot': 'icon:' + encodeURIComponent('https://gspy.uk/images/map-circle-dot.png?') + '%7Canchor:center',
    };

    let url = 'https://maps.googleapis.com/maps/api/staticmap?scale=2&maptype=roadmap';

    if (location) {
        url += 'center=' + location.latitude + ',' + location.longitude;
    }

    if (markers) {
        markers.forEach(marker => {
            url += '&markers=' + [
                (marker.size && 'size:' + marker.size),
                (marker.label && 'label:' + marker.label),
                (marker.color && 'color:' + marker.color),
                (marker.icon && icons[marker.icon]),
                marker.latitude + ',' + marker.longitude
            ].join('%7C')

        })

    }

    if (zoom) {
        url += '&zoom=' + zoom;
    }

    url += '&size=' + size[0] + 'x' + size[1] + '&maptype=roadmap&key=' + googleKey;

    return url;
}

export {
    useMapUrl,
}